import { render, staticRenderFns } from "./PlayerMain.vue?vue&type=template&id=39898ef2&scoped=true&"
import script from "./PlayerMain.vue?vue&type=script&lang=js&"
export * from "./PlayerMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMain.vue?vue&type=style&index=0&id=39898ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39898ef2",
  null
  
)

export default component.exports